import fetchEvents from './fetchEvents';
import fetchEvent from './fetchEvent';
import createEvent from './createEvent';
import updateEvent from './updateEvent';
import deleteEvent from './deleteEvent';
import fetchEventRegistrations from './fetchEventRegistrations';
import createEventRegistration from './createEventRegistration';
import updateEventRegistration from './updateEventRegistration';
import deleteEventRegistration from './deleteEventRegistration';
import fetchWhatsAppConfigs from './fetchWhatsAppConfigs';
import createWhatsAppConfig from './createWhatsAppConfig';
import updateWhatsAppConfig from './updateWhatsAppConfig';
import deleteWhatsAppConfig from './deleteWhatsAppConfig';
import sendWhatsAppNotification from './sendWhatsAppNotification';
import generateEventShareUrl from './generateEventShareUrl';
import fetchEventPublic from './fetchEventPublic';

export default {
  fetchEvents,
  fetchEvent,
  createEvent,
  updateEvent,
  deleteEvent,
  fetchEventRegistrations,
  createEventRegistration,
  updateEventRegistration,
  deleteEventRegistration,
  fetchWhatsAppConfigs,
  createWhatsAppConfig,
  updateWhatsAppConfig,
  deleteWhatsAppConfig,
  sendWhatsAppNotification,
  generateEventShareUrl,
  fetchEventPublic,
};
